<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && milestone">
			<div class="col-sm-12">
				<br>
				<!-- activity -->
				<div class="row activity">
					<div class="col-md-12">
						<h5 class="mt-3">{{'labels.activity-data' | translate}}</h5>
					</div>
					<div class="form-group col-md-4">
						<label>
							{{ 'labels.name' | translate }}:
							<span style="font-weight: bold;">{{activity?.name}}</span>
						</label>
					</div>
					<div class="form-group col-md-4">
						<label>
							{{ 'labels.startdate' | translate }}:
							<span style="font-weight: bold;">
								{{activity?.startdate | date:'dd/MM/yyyy'}}
							</span>
						</label>
					</div>
					<div class="form-group col-md-4">
						<label>
							{{ 'labels.stopdate' | translate }}:
							<span style="font-weight: bold;">
								{{activity?.stopdate | date:'dd/MM/yyyy'}}
							</span>
						</label>
					</div>
				</div>
				<br>
				<div class="row">

					<!-- name -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.name' | translate }}*</label>
						<input
							[(ngModel)]="milestone.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- milestonedate -->
					<div class="form-group col-md-4">
						<label>{{'labels.date' | translate}}*</label>
						<app-datepicker
							[(ngModel)]="milestone.milestonedate"
							name="milestonedate"
							required
							#milestonedate="ngModel"
							[min]="activity?.startdateasdate"
							[max]="activity?.stopdateasdate"
							[ngClass]="{'is-invalid': editForm.submitted && milestonedate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && milestonedate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- description -->
					<div class="form-group col-md-12">
						<label>{{ 'labels.description' | translate }}*</label>
						<quill-editor
							name="description"
							[required]="true"
							[(ngModel)]="milestone.description"
							placeholder
							#description="ngModel"
							[ngClass]="editForm.submitted && description.invalid ? 'is-invalid' : ''">
						</quill-editor>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && description.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
